// extracted by mini-css-extract-plugin
export var link = "social-item-module--link--dedlF";
export var instagram = "social-item-module--instagram--HQ2x6";
export var telegram = "social-item-module--telegram--UbASZ";
export var facebook = "social-item-module--facebook--ygk6Y";